"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitDate = exports.validateAndFormattingDate = exports.formatDate = void 0;
var moment_1 = __importDefault(require("moment"));
function addLeadingZero(num) {
    return num < 10 ? '0' + num : num;
}
var formatDate = function (inputDate, _a) {
    var isRTL = _a.isRTL, format = _a.format;
    var date = addLeadingZero(inputDate.getDate());
    var month = addLeadingZero(inputDate.getMonth() + 1);
    var hours = addLeadingZero(inputDate.getHours());
    var minutes = addLeadingZero(inputDate.getMinutes());
    var year = inputDate
        .getFullYear()
        .toString()
        .substring(2, 4);
    var dateString = '';
    if (format !== 'time') {
        dateString += isRTL ? "".concat(date, "/").concat(month, "/").concat(year) : "".concat(month, "/").concat(date, "/").concat(year);
    }
    if (format !== 'date') {
        dateString += " ".concat(hours, ":").concat(minutes);
    }
    return dateString;
};
exports.formatDate = formatDate;
var validateAndFormattingDate = function (val) {
    var fromvalFormatted = (0, moment_1.default)(val, 'DD/MM/YYYY').format('YYYY-MM-DD');
    return new Date(!isNaN(+new Date(fromvalFormatted)) ? fromvalFormatted : val);
};
exports.validateAndFormattingDate = validateAndFormattingDate;
var splitDate = function (value) {
    var _a;
    var parts = (_a = value === null || value === void 0 ? void 0 : value.toString()) === null || _a === void 0 ? void 0 : _a.split('/');
    return parts[(parts === null || parts === void 0 ? void 0 : parts.length) > 1 ? 2 : 0];
};
exports.splitDate = splitDate;
